import Keycloak, { KeycloakLoginOptions } from 'keycloak-js';
import { BehaviorSubject } from 'rxjs';

import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { SnackbarService } from '../snackbar-service/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);
  private readonly _snackBarService = inject(SnackbarService);

  redirectToLoginPage(options?: KeycloakLoginOptions): Promise<void> {
    return this.keycloak.login(options || { redirectUri: environment.keycloak.redirectUri });
  }

  isLoggedIn(): boolean {
    return !!this.keycloak.authenticated;
  }

  getToken(): string {
    if (!this.keycloak.token) {
      throw new Error('No token available');
    }
    return this.keycloak.token;
  }

  async refreshTokenIfNeeded(): Promise<void> {
    if (this.isTokenExpired()) {
      try {
        await this.keycloak.updateToken(30);
      } catch (error) {
        console.error('Error refreshing token', error);
        throw error;
      }
    }
  }

  logout(): void {
    this.keycloak.logout({ redirectUri: environment.keycloak.postLogoutRedirectUri });
  }

  isTokenExpired(): boolean {
    if (!this.keycloak.tokenParsed || !this.keycloak.tokenParsed.exp) {
      return true;
    }
    const exp = this.keycloak.tokenParsed.exp;
    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  }
  showAuthenticationMessage(): void {
    this._snackBarService.openFailureSnackBar('Você não está autenticado');
  }
}